import { reactive, computed, useContext } from "@nuxtjs/composition-api";
const state = reactive({
  isPriceRequestModalOpen: false,
  requestedProduct: null
});
function usePriceRequest() {
  var _a, _b, _c;
  const { app } = useContext();
  const showPriceOnQuoteProduct = (_c = (_b = (_a = app.$wm) == null ? void 0 : _a.catalog) == null ? void 0 : _b.showPriceOnQuoteProducts) != null ? _c : true;
  const openPriceRequestModal = (product) => {
    state.requestedProduct = product;
    state.isPriceRequestModalOpen = true;
  };
  const closePriceRequestModal = () => {
    state.isPriceRequestModalOpen = false;
  };
  const isQuoteProduct = (product, attributes) => {
    var _a2, _b2, _c2, _d, _e;
    const quotableAtt = (_b2 = (_a2 = app.$wm) == null ? void 0 : _a2.catalog) == null ? void 0 : _b2.quoteProductIndicator;
    const isQuotable = quotableAtt && ((_c2 = attributes[quotableAtt]) == null ? void 0 : _c2.raw_value) ? attributes[quotableAtt].raw_value === "1" : false;
    const quotableFunc = (_e = (_d = app.$wm) == null ? void 0 : _d.catalog) == null ? void 0 : _e.isQuoteProductCallback;
    return quotableFunc ? quotableFunc(product, attributes, isQuotable) : isQuotable;
  };
  return {
    isPriceRequestModalOpen: computed(() => state.isPriceRequestModalOpen),
    requestedProduct: computed(() => state.requestedProduct),
    showPriceOnQuoteProduct,
    openPriceRequestModal,
    closePriceRequestModal,
    isQuoteProduct
  };
}
export {
  usePriceRequest
};
